import { queryOptions } from '@tanstack/react-query';

import { harvestProofApi } from '../apis/harvest-proof';

import { Filters } from '@data-access';

export const harvestProofQueries = {
  all: ['harvest-proof'] as const,
  list: (filters: Filters) =>
    queryOptions({
      queryKey: [...harvestProofQueries.all, 'list', filters],
      queryFn: () => harvestProofApi.list(filters),
    }),
  detail: (id: number) =>
    queryOptions({
      queryKey: [...harvestProofQueries.all, 'detail', id],
      queryFn: () => harvestProofApi.getOne(id),
      enabled: id > 0,
    }),
  publicForm: (token: string) =>
    queryOptions({
      queryKey: [...harvestProofQueries.all, 'public', token],
      queryFn: () => harvestProofApi.getPublicForm(token),
      enabled: Boolean(token),
    }),
};
